import { render, staticRenderFns } from "./Art.vue?vue&type=template&id=fde0b3de&scoped=true"
import script from "./Art.vue?vue&type=script&lang=js"
export * from "./Art.vue?vue&type=script&lang=js"
import style0 from "./Art.vue?vue&type=style&index=0&id=fde0b3de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde0b3de",
  null
  
)

export default component.exports